<template>
  <div>
    <v-tabs
      v-if="languagesList.length > 1"
      v-model="active"
      color="primary"
      dark
      slider-color="secondary"
    >
      <v-tab
        v-for="lang in languagesList"
        :key="lang.code"
        ripple
        class="text--white"
      >
        {{ lang.flag }} {{ lang.name }}
      </v-tab>
      <v-tabs-items v-model="active">
        <slot :language="languagesList[active]"/>
      </v-tabs-items>
    </v-tabs>
    <slot
      v-else
      :language="defaultLang"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TranslationsTabs',

  props: {
    value: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      active: null
    }
  },

  computed: {
    ...mapGetters([
      'languagesList',
      'defaultLang'
    ])
  },

  async created () {
    if (this.languagesList.length) {
      this.value = this.defaultLang
      return
    }

    const locale = await this.$http.make('settings').find('general/locale')
    const languages = await this.$http.make('language').get()
    this.setLanguagesList(languages)
    this.setDefaultLang(locale.language)

    this.value = this.defaultLang
  },

  methods: {
    ...mapActions([
      'setLanguagesList',
      'setDefaultLang'
    ])
  }
}
</script>
